import type { PropType } from 'vue';
import { type ButtonProps, buttonProps } from '../button/button';
import type { TooltipPlacement } from '../tooltip/tooltip';

export interface ButtonPresetsProps extends ButtonProps {
    type: 'action' | 'create' | 'download' | 'reload' | 'trash';
    tooltip?: string;
    tooltipPlacement?: TooltipPlacement;
    isActive?: boolean;
}

export const buttonPresetsProps = {
    ...buttonProps,
    type: {
        type: String as PropType<ButtonPresetsProps['type']>,
        default: undefined,
        required: false,
    },
    tooltip: {
        type: String as PropType<ButtonPresetsProps['tooltip']>,
        default: undefined,
        required: false,
    },
    tooltipPlacement: {
        type: String as PropType<ButtonPresetsProps['tooltipPlacement']>,
        default: 'auto',
        required: false,
    },
    isActive: {
        type: Boolean as PropType<ButtonPresetsProps['isActive']>,
        default: false,
        required: false,
    },
};
